<template>
  <div class="preference-switch">
    <!--id: {{id}}<br>-->
    <!--prop: {{prop}}<br>-->
      <label :for="label">
        {{ $t('BetSlip.placement.'+ label + '.label')}}
      </label>
        <v-checkbox v-model.lazy="combo"
          :id="id"
          :disabled="currentBetSlipState>=2"
          @click="toggleSettings(id)" ></v-checkbox>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'

  export default {
    name: 'preferenceSwitch',
    props: ['id', 'currentBetSlipState', 'label'],

    mixins: [
    ],

    data () {
      return {
        prop: false
      }
    },

    computed: {
      storedVal: {
        get: function () {
          return store.getters['sbBetslipState/' + this.id]
        },
        set: function (newVal) {
//          console.log(this.id + ' newVal: ' + newVal)
          store.commit('sbBetslipState/set' + this.capitalizeFirstLetter(this.id), newVal)
        }
      },
      combo: {
        get: function () {
          return this.prop && this.storedVal
        },
        set: function (newVal) {
          return newVal
        }
      }
    },

    methods: {
      toggleSettings (id) {
        var self = this
//        console.log('toggle settings for ' + id + ': ' + self[id])
        if (this.prop) {
          store.dispatch('overlayState/activateBetslipConfirm', id).then(function (sure) {
            setTimeout(function () {
              Vue.set(self, 'prop', !sure)
              Vue.set(self, 'storedVal', !sure)
            })
          })
        } else {
          Vue.set(self, 'prop', true)
          Vue.set(self, 'storedVal', true)
        }
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
    },

    created: function () {
      this.prop = store.getters['sbBetslipState/' + this.id]
    },
    mounted: function () {
      this.prop = store.getters['sbBetslipState/' + this.id]
    },

    watch: {}
  }
</script>

<style lang="stylus" scoped>
  .preference-switch
    background: #F0F3F8
    padding: 7px 12px
    display: flex
    align-items: center
    font-size: 14px
    margin: 12px -12px -12px -12px
    justify-content: space-between
    label
      flex: 1 1 auto
      vertical-align: middle
      color: #06283b
      font-weight: 600
    .switch
       flex:  0 auto
       margin-left: auto

      >>>.input-group
        /* display: inline-block
        vertical-align: middle */
        width: auto

      >>>.input-group__input
        background: none !important
        flex:  0 auto !important

</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/preferenceSwitch.vue